import React from 'react';
import { Typography, Space, Tag } from 'antd';
const { Text } = Typography;

const Footer: React.FC = () => {
  return (
    <div style={{ textAlign: 'center', padding: 24 }}>
      <Space size="middle">
        <div style={{ textAlign: 'center', padding: '16px 0', color: '#999' }}>
          <Text>
            © {new Date().getFullYear()} Activata Ltd. All rights reserved.
          </Text>
          <br />
          <Tag color="blue" style={{ marginTop: 8 }}>
            Version {APP_VERSION}
          </Tag>
        </div>
      </Space>
    </div>
  );
};

export default Footer;
